import { render } from "./DispoLieuEleve.vue?vue&type=template&id=2065bd39&scoped=true"
import script from "./DispoLieuEleve.vue?vue&type=script&lang=js"
export * from "./DispoLieuEleve.vue?vue&type=script&lang=js"

import "./DispoLieuEleve.vue?vue&type=style&index=0&id=2065bd39&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2065bd39"]])

export default __exports__